import styled from "styled-components";

import {
  DefaultParagraphMediumFactory,
  DefaultTitleLargeFactory,
  DefaultTitleSmallFactory,
} from "../../Habitacional/core/Typograph/Typograph.Style";

export const FinancialInformationSectionContainer = styled.section(
  ({ theme }) => ({
    paddingTop: "40px",
    paddingBottom: "40px",
    marginBottom: "0 !important",

    [theme.breakpoint.lg()]: {
      paddingTop: "60px",
      paddingBottom: "60px",
    },
  })
);

export const FinancialInformationSectionContent = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
}));

export const FinancialInformationSectionTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const FinancialInformationSectionList = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
}));

export const FinancialInformationSectionItem = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",

  span: {
    ...DefaultParagraphMediumFactory({ theme }),
  },
}));

export const FinancialInformationSectionItemTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleSmallFactory({ theme }),
  fontWeight: "600",
}));

export const FinancialInformationSectionListFooter = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const FinancialInformationSectionItemFooter = styled.div(() => ({
  display: "flex",
  justifyContent: "flex-end",
}));
